import { NgModule } from '@angular/core';
import { APP_BASE_HREF, PlatformLocation } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from './app.routing.module';
import { PlessSharedModule } from './shared/pless-shared.module';

import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { KYMW1002Module } from './kymw/kymw10/kymw1002/kymw1002.module';
import { AppCommonsModule } from './commons/app-commons.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { KYMWModule } from './kymw/kymw.module';
import { TestModule } from './kymw/test/test.module';
import { KYMW1000Module } from './kymw/kymw10/kymw1000/kymw1000.module';
import { KYMW1001Module } from './kymw/kymw10/kymw1001/kymw1001.module';
import { AuthModule } from './kymw/kymw10/auth/auth.module';
import { EmployeeModule } from './kymw/kymw10/employee/employee.module';
import { PartnerModule } from './kymw/kymw10/partner/partner.module';

/**
 * baseHrefを取得し設定させるためのメソッド
 *
 * @export getBaseHref
 * @param {PlatformLocation} platformLocation
 * @returns {string}
 */
export function getBaseHref(platformLocation: PlatformLocation): string {
  return platformLocation.getBaseHrefFromDOM();
}

@NgModule({
  // アプリで使用するライブラリのインポート(子要素に記載しても無効)
  imports: [
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    PlessSharedModule,
    SharedModule,
    AppCommonsModule,
    // BookProofMailSendModule,
    KYMW1000Module,
    KYMW1001Module,
    KYMW1002Module,
    AuthModule,
    EmployeeModule,
    PartnerModule,
    KYMWModule,
    TestModule, // FIXME: 後で消す
    NgbModule,
    FontAwesomeModule
  ],
  // アプリで使用する ngModule Componentの定義
  declarations: [
    AppComponent,
  ],
  // DI(data injection)元となるクラス(Serviceとか)を登録
  providers: [
    {
      provide: APP_BASE_HREF,
      useFactory: getBaseHref,
      deps: [PlatformLocation]
    },  
  ],
  // 最初に起動するコンポーネントを指定
  bootstrap: [AppComponent]
})
export class AppModule { }
